import axios from "axios";
import { adminDomain } from "../urlConst/domainUrl";

const API_URL_GET_MY_ACCOUNT = adminDomain + "/api/v1/my_account";

const API_URL_UPDATE_MY_ACCOUNT = adminDomain + "/api/v1/update_my_account";

const API_URL_UPDATE_MY_PASSWORD =
  adminDomain + "/api/v1/update_my_account_password";

//   Get User
const getMyAccount = async (token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };
  const res = await axios.get(API_URL_GET_MY_ACCOUNT, config);

  const newToken = res.headers.authorization;
  return { res, newToken };
};

//   Update User
const updateMyAccount = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };
  const res = await axios.put(API_URL_UPDATE_MY_ACCOUNT, data, config);

  const newToken = res.headers.authorization;
  return { res, newToken };
};

//   Update Password
const updateMyPassword = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };
  const res = await axios.put(API_URL_UPDATE_MY_PASSWORD, data, config);

  const newToken = res.headers.authorization;
  return { res, newToken };
};

const profileService = {
  getMyAccount,
  updateMyAccount,
  updateMyPassword,
};

export default profileService;
